export default "__VITE_ASSET__C9C44MKG__";